import * as React from 'react';

import ForcePasswordChangeForm from '../containers/auth/ForcePasswordChangeForm';

export default function(params) {
  return (
    <React.Fragment>
      <div className="log__cont log__cont--force">
        <ForcePasswordChangeForm />
      </div>
    </React.Fragment>
  );
};

